import { ModuleActionViewEnum } from "../enums/moduleActionViewEnum";

import * as appsettings from "../appsettings";
import * as dialog from "../dialog";
import * as main from "../main";
import * as navigation from "../navigation";
import * as viewmode from "../viewmode";

/**
 * Refreshes the grid 
 */
export function refreshGrid(gridname: string): void {

    const grid = $("#" + gridname).data("kendoGrid");

    if (grid != undefined) {
        grid.dataSource.read();
    }
}

/**
* Init (binding button actions)
* @param { any } DOMelement
*/
export function showItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    // Prevent default behaviour
    e.preventDefault();

    // Set mode 
    viewmode.setViewMode(ModuleActionViewEnum.Show);

    // select the item
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as FunctionGridVM;

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("AdministrationFunction/Show?functionId=" + dataItem.FunctionID + "&breadcrumbLabel=" + dataItem.Label);
}

export function editItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    // Prevent default behaviour
    e.preventDefault();

    // Set mode 
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // select the item
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as FunctionGridVM;

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("AdministrationFunction/Edit?functionId=" + dataItem.FunctionID + "&breadcrumbLabel=" + dataItem.Label);
}

export function editMenuItemTree(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    // Prevent default behaviour
    e.preventDefault();

    // Set mode 
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // select the item
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as FunctionGridVM;

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("AdministrationFunction/Adapt?functionId=" + dataItem.FunctionID + "&breadcrumbLabel=" + dataItem.Label);
}

export function deleteItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    const event = e;
    const data = this;

    function callbackYes(event: JQuery.Event & { currentTarget: HTMLElement }, data: kendo.ui.Grid): void {
        // Prevent default behaviour 
        event.preventDefault();

        const dataItem = data.dataItem($(event.currentTarget).closest("tr")) as FunctionGridVM;
        removeItem(dataItem.FunctionID);
    }

    function callingCallback() {
        callbackYes(event, data);
    }

    dialog.createDialog(callingCallback, function () { });
}

export function removeItem(functionId: number): void {
    $.ajax({
        type: "POST",
        url: appsettings.getUrl("AdministrationFunction/Delete"),
        data: { functionId: functionId },
        dataType: 'json',
        success: function (responseData: responseModel | undefined | null) {

            refreshGrid("FunctionsGrid");

            if (responseData != undefined && responseData != null && !responseData.Succesfully) {
                main.makeResultMessage(responseData);
            }
        }
    });
}

export function onCheckChangedTree(e: kendo.ui.TreeViewCheckEvent): void {

    const treeview = $("#treeView").data("kendoTreeView");
    const item = treeview.dataItem(e.node);
    const functionId = $("#FunctionID").val();

    $.ajax({
        type: "POST",
        url: appsettings.getUrl("AdministrationFunction/SetModuleFunction"),
        data: {
            moduleId: item.id,
            functionId: functionId,
            isChecked: item.get("checked")
        },
        dataType: 'json',
        success: function (responseData: responseModel | undefined | null) {

            if (responseData != undefined && responseData != null && !responseData.Succesfully) {
                main.makeResultMessage(responseData);
            }
        }
    });
}
